import { useState } from "react";

export const FileUploadWithLimit = ({ rowId, fileForRow, onScreenshotChange }) => {
  const [fileError, setFileError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    const MAX_SIZE = 4 * 1024 * 1024; // 1 MB

    if (file && file.size > MAX_SIZE) {
      setFileError(`File size must not exceed 4 MB.`);
      e.target.value = "";
      onScreenshotChange(rowId, null);
      return;
    }

    setFileError("");
    onScreenshotChange(rowId, file);
  };

  return (
    <>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="border border-slate-300 bg-white text-slate-700 rounded-lg py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm file:mr-2 file:py-1 file:px-2 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700"
      />

      {fileError && (
        <p className="text-red-600 text-xs mt-1">{fileError}</p>
      )}

      {fileForRow && !fileError && (
        <p className="text-green-600 text-xs font-medium mt-1">
          ✓ {fileForRow.name}
        </p>
      )}
    </>
  );
};
